import { render, staticRenderFns } from "./SKUListItem.vue?vue&type=template&id=24b99c88&scoped=true&"
import script from "./SKUListItem.vue?vue&type=script&lang=js&"
export * from "./SKUListItem.vue?vue&type=script&lang=js&"
import style0 from "./SKUListItem.vue?vue&type=style&index=0&id=24b99c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b99c88",
  null
  
)

export default component.exports